import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';

// Components
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Subheading from '../../components/Subheading';
import ContactsMap from '../../components/ContactsMap';
import ContactsMapGoogle from '../../components/ContactsMap/GMap';
import FeedbackForm from '../../components/Forms/FeedbackForm';

// Utils
import { plainPhoneNumber } from '../../utils/telephone';

// Config
import config from '../../config';

// Styles
import styles from './Contacts.styl';

const cx = classNames.bind(styles);

export default function Contacts() {
  const intl = useIntl();
  const {
    delivery_balloon,
    help_number,
    service_phone,
    contact_email,
    coordinates,
    declension,
    name,
  } = useSelector(state => state.city.userCity);

  const cityCenter = [...coordinates];

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: 'page.contacts.helmet' }, { declension, name })}</title>
        <meta
          name="description"
          content={intl.formatMessage(
            { id: 'page.contacts.helmet.description' },
            { declension, name },
          )}
        />
      </Helmet>
      <Container className={cx('Contacts')}>
        <Heading level={2} className={cx('Contacts__title')}>
          {intl.formatMessage({ id: 'page.contacts.title' })}
        </Heading>
        <div className={cx('Contacts__headline')}>
          <Subheading className={cx('Contacts__text')}>
            <div dangerouslySetInnerHTML={{ __html: delivery_balloon }} />
          </Subheading>
          <div className={cx('Contacts__wrapper')}>
            {/*{help_number && (*/}
            {/*  <div className={cx('Contacts__contact')}>*/}
            {/*    <a className={cx('Contacts__link')} href={`tel:${plainPhoneNumber(help_number)}`}>*/}
            {/*      {help_number}*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*)}*/}
            <div className={cx('Contacts__contact')}>
              <div className={cx('Contacts__desc')}>
                {intl.formatMessage({ id: 'page.contacts.description' })}
              </div>
            </div>
            {service_phone && (
              <div className={cx('Contacts__contact')}>
                <a className={cx('Contacts__link')} href={`tel:${plainPhoneNumber(service_phone)}`}>
                  {service_phone}
                </a>
                {intl.formatMessage({ id: 'page.contacts.servicePhone.label' })}
              </div>
            )}
            {contact_email && (
              <div className={cx('Contacts__contact')}>
                <a className={cx('Contacts__link')} href={`mailto:${contact_email}`}>
                  {contact_email}
                </a>
                {intl.formatMessage({ id: 'page.contacts.mail' })}
              </div>
            )}
          </div>
        </div>
        {config.legal === 'pl' ? (
          <ContactsMapGoogle center={cityCenter} />
        ) : (
          <ContactsMap center={cityCenter} />
        )}
        <FeedbackForm />
      </Container>
    </>
  );
}
